import React, { useState, useEffect } from 'react';
import config from '../config';

  const { apiBaseURL } = config;

  // Helper function to construct API URLs
  export const getApiUrl = (endpoint) => {
    return `${apiBaseURL}${endpoint}`;
  };

  const ProfileInfo = ({ data }) => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      if (!data || !data.stock || !data.stock.symbol) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const symbol = data.stock.symbol;
        const response = await fetch(`${apiBaseURL}/api/profile/${symbol}`);

        if (!response.ok) {
          throw new Error(`Failed to fetch profile data for ${symbol}`);
        }

        const profileResult = await response.json();
        console.log("Profile data:", profileResult);
        setProfileData(profileResult);
        setError(null);
      } catch (err) {
        console.error("Error fetching profile data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfileData();
  }, [data]);

  // Helper function to format phone numbers
  const formatPhoneNumber = (phoneNumberString) => {
    if (!phoneNumberString) return 'N/A';
    // Assuming US format; adjust as needed
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return phoneNumberString;
  };

  // Handle loading state
  if (loading) {
    return (
      <div className="profile-loading">
        <div className="spinner"></div>
        <p>Loading profile data...</p>
      </div>
    );
  }

  // Handle error state
  if (error) {
    return (
      <div className="profile-error">
        <h3>Error Loading Profile</h3>
        <p>{error}</p>
      </div>
    );
  }

  // Handle no data state
  if (!profileData || !profileData.profile) {
    return <div className="profile-error">No profile data available for this stock</div>;
  }

  const profile = profileData.profile;
  
  return (
    <div className="profile-info">
      <div className="company-header">
        <h3>Company Profile</h3>
        <div className="company-basic-info">
          <div className="row">
            <div className="info-item">
              <span className="info-label">Symbol</span>
              <span className="info-value">{profileData.symbol || 'N/A'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Company Name</span>
              <span className="info-value">{profile.company_name || 'N/A'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Sector</span>
              <span className="info-value">{profile.sector || 'N/A'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Industry</span>
              <span className="info-value">{profile.industry || 'N/A'}</span>
            </div>
          </div>
        </div>
      </div>
      
      {profile.description && (
        <div className="company-description">
          <h4>About {profile.company_name}</h4>
          <p>{profile.description}</p>
        </div>
      )}
      
      <div className="key-stats">
        <h4>Key Information</h4>
        <div className="stats-grid">
          <div className="stat-column">
            <h5>Company Details</h5>
            <div className="stat-item">
              <span className="stat-label">CEO</span>
              <span className="stat-value">{profile.ceo || 'N/A'}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Employees</span>
              <span className="stat-value">{profile.employees ? profile.employees.toLocaleString() : 'N/A'}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Founded Year</span>
              <span className="stat-value">{profile.founded_year || 'N/A'}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Website</span>
              <span className="stat-value">
                {profile.website ? (
                  <a href={profile.website} target="_blank" rel="noopener noreferrer">
                    {profile.website.replace(/^https?:\/\/(www\.)?/, '')}
                  </a>
                ) : 'N/A'}
              </span>
            </div>
          </div>
          
          <div className="stat-column">
            <h5>Contact Information</h5>
            <div className="stat-item">
              <span className="stat-label">Address</span>
              <span className="stat-value">{profile.address || 'N/A'}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Phone</span>
              <span className="stat-value">{formatPhoneNumber(profile.phone)}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Last Updated</span>
              <span className="stat-value">
                {profile.updated_at ? new Date(profile.updated_at).toLocaleDateString() : 'N/A'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileInfo;